import React from "react";
import { productionChartTabToolTips as pctt } from "../../../../agent-production/constants/agentProductionConstants";
import PropTypes from "prop-types";

const SummaryTable = ({ title, cardData }) => {
    const cards = cardData?.map((card, key) => {
        return (
            <div className="summary-table-card" key={`card-${key}-${card.id}`}>
                <p>{cardData.find(cardData => cardData.id === card.id)?.value}</p>
                <span>{pctt[card.id]?.label}</span>
            </div>
        );
    });

    return (
        <div className="summary-table-container">
            <div className="summary-table-title">{title}</div>
            <div className="summary-table-cards-container">{cards}</div>
        </div>
    );
};

SummaryTable.propTypes = {
    cardData: PropTypes.array,
    title: PropTypes.string,
};

export default SummaryTable;
